export default __webpack_public_path__ + "static/media/crew-4.b919cd97.png";